import React from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Button, DatePicker, Form, Icon, Select, Spin, Table, Pagination, Divider } from "antd";
import { getWithdraw } from "../../../actions/WithdrawAction";
import moment from "moment";
import UpdateWithdraw from "./UpdateWithdraw";
import WithdrawDetails from "./WithdrawDetails";
import {Utils} from "../../../services/Utlis";

const { Option } = Select;

class Withdraw extends React.Component {
    state = {
        startValue: null,
        endValue: null,
        endOpen: false,
        modalVisible: false,
        status: null,
        pageNumber: 1
    };

    componentDidMount() {
        const { mainPartnerId } = this.props.affiliates;
        const { affiliateId } = this.props.affiliates;
        const { pageNumber } = this.state;

        mainPartnerId && this.props.dispatch(getWithdraw(mainPartnerId, affiliateId, pageNumber));
    }

    onPageChange = (current) => {
        this.setState({ pageNumber: current });
    }

    // On page and mainpartner change get new data
    componentDidUpdate(prevProps, prevState) {
        const { mainPartnerId, affiliateId } = this.props.affiliates;
        const { pageNumber } = this.state;
        const { startValue, endValue } = this.state;

        if (prevState.pageNumber !== pageNumber || prevProps.affiliates.mainPartnerId !== mainPartnerId) {
            this.props.dispatch(getWithdraw(mainPartnerId, affiliateId, pageNumber, {
                status: this.state.status,
                dateFrom: startValue && startValue.format('YYYY-MM-DD'),
                dateTo: endValue && endValue.format('YYYY-MM-DD'),
            }));
        }
    }

    onChangeStatus = (value) => {
        this.setState({
            status: value,
        });
    };

    disabledStartDate = startValue => {
        const { endValue } = this.state;
        if (!startValue || !endValue) {
            return false;
        }
        return startValue.valueOf() > endValue.valueOf();
    };

    disabledEndDate = endValue => {
        const { startValue } = this.state;
        if (!endValue || !startValue) {
            return false;
        }
        return endValue.valueOf() <= startValue.valueOf();
    };

    onChange = (field, value) => {
        this.setState({
            [field]: value,
        });
    };

    onStartChange = value => {
        this.onChange('startValue', value);
    };

    onEndChange = value => {
        this.onChange('endValue', value);
    };

    handleStartOpenChange = open => {
        if (!open) {
            this.setState({ endOpen: true });
        }
    };

    handelFiltersWithdraw = () => {
        const { form } = this.props;
        const { pageNumber } = this.state;
        const { mainPartnerId, affiliateId } = this.props.affiliates;

        form.validateFields((err, values) => {
            if (!err) {
                const { startDate, endDate, status } = values;

                this.setState({
                    filterData: {
                        status: values.status
                    }
                });
                this.props.dispatch(getWithdraw(mainPartnerId, affiliateId, pageNumber, {
                    dateFrom: startDate && startDate.format('YYYY-MM-DD'),
                    dateTo: endDate && endDate.format('YYYY-MM-DD'),
                    status
                }))
            }
            // form.resetFields();
        })
    };

    clearItem = (type) => {
        this.setState({
            [type]: undefined,
        });
        this.props.form.setFieldsValue({
            [type]: undefined,
        });
    };

    render() {

        const antIcon = <Icon type="loading" className="ta--ant_loader" spin />;
        const { getFieldDecorator } = this.props.form;
        const { mainWithdraw } = this.props.withdraw;
        const dateFormat = "YYYY-MM-DD";

        const sorter = (a, b) => {
            if (a.id < b.id) {
                return -1;
            }
            if (a.id > b.id) {
                return 1;
            }
            return 0;
        };

        const columns = [
            {
                title: this.props.intl.messages.id,
                dataIndex: 'id',
                key: 'id',
                filters: [],
                sorter: sorter,
                sortDirections: ['ascend' , 'descend'],
            },
            {
                title: this.props.intl.messages.date,
                dataIndex: 'date',
                key: 'date',
            },
            {
                title: this.props.intl.messages.aff_name,
                dataIndex: 'aff_name',
                key: 'aff_name',
            },
            {
                title: this.props.intl.messages.amount,
                dataIndex: 'amount',
                key: 'amount',
                render: amount => Utils.numberWithCommas(amount)
            },
            {
                title: this.props.intl.messages.info,
                dataIndex: 'info',
                key: 'info',
            },
            {
                title: this.props.intl.messages.status,
                dataIndex: 'status',
                key: 'status',
                width: '100px',
                render: (amount, record) => (
                    record.status === 1 ?
                        <span className="ta--pending ta--fw-b">{this.props.intl.messages.waiting}</span> :
                        record.status === 2 ?
                            <span className="ta--success ta--fw-b">{this.props.intl.messages.success}</span> :
                            record.status === 3 ?
                                <span className="ta--cancel ta--fw-b">{this.props.intl.messages.cancelled}</span> : ""
                ),
            },
            {
                title: '',
                dataIndex: 'update',
                key: 'update',
                width: '30px',
                render: (value, row, index) => (
                    <div>
                        <UpdateWithdraw affiliateId={row.id} mainPartnerId={this.props.user.mainPartnerId} status={row.status} />
                    </div>
                ),
            },
            {
                title: '',
                dataIndex: 'view',
                key: 'view',
                width: '20px',
                render: (value, row, index) => (                    
                    <WithdrawDetails withdrawAmount={row.amount} type={row.type} id={row.id} />
                ),
            },
        ];

        const data = mainWithdraw ? Object.keys(mainWithdraw.Withdrawals).map(key => {
            return {
                id: mainWithdraw.Withdrawals[key].Id,
                key: mainWithdraw.Withdrawals[key].Id,
                date: moment(mainWithdraw.Withdrawals[key].Date).format(dateFormat),
                aff_name: mainWithdraw.Withdrawals[key].AffiliateName,
                amount: mainWithdraw.Withdrawals[key].Amount,
                info: mainWithdraw.Withdrawals[key].Info,
                status: mainWithdraw.Withdrawals[key].Status,
                type: mainWithdraw.Withdrawals[key].Type,
            }
        }).sort(this.sorter) : [];

        return (
            <div>
                <h2 className='ta--main-header'>{this.props.intl.messages.withdraw}</h2>
                <div className='ta--flex ta--report-filter'>
                    <Form layout="vertical" className='ta--flex ta--align-center ta-flex-grid ta-w100 '>
                        <Form.Item label={this.props.intl.messages.status} className='ta--flex-grid__item ta--col-3'>
                            {getFieldDecorator('status')(
                                <Select 
                                    onChange={this.onChangeStatus} 
                                    placeholder={this.props.intl.messages.status}
                                    dropdownRender={menu => (
                                        <div>
                                          {menu}
                                          <Divider className="ant-select-tree-dropdown" />
                                          <div
                                            className="ant-select-tree-dropdown-render-div"
                                            onMouseDown={e => e.preventDefault()}
                                            onClick={() => this.clearItem('status')}
                                          >
                                            <Icon type="delete" /> Clear
                                          </div>
                                        </div>
                                      )}
                                >
                                    <Option value={2}>{this.props.intl.messages.success}</Option>
                                    <Option value={3}>{this.props.intl.messages.cancelled}</Option>
                                    <Option value={1}>{this.props.intl.messages.waiting}</Option>
                                </Select>
                            )}
                        </Form.Item>

                        <Form.Item label={this.props.intl.messages.start_date}
                            className='ta--flex-grid__item ta--col-3'>
                            {getFieldDecorator('startDate')(
                                <DatePicker
                                    disabledDate={this.disabledStartDate}
                                    format={dateFormat}
                                    placeholder={this.props.intl.messages.start_date}
                                    onChange={this.onStartChange}
                                    onOpenChange={this.handleStartOpenChange}
                                />
                            )}
                        </Form.Item>

                        <Form.Item label={this.props.intl.messages.end_date} className='ta--flex-grid__item ta--col-3'>
                            {getFieldDecorator('endDate')(
                                <DatePicker
                                    disabledDate={this.disabledEndDate}
                                    format={dateFormat}
                                    placeholder={this.props.intl.messages.end_date}
                                    onChange={this.onEndChange}
                                    onOpenChange={this.handleStartOpenChange}
                                />
                            )}
                        </Form.Item>

                        <Button className='ta--mb-4 ta--mt-24 ta--ml-auto' key="done" onClick={this.handelFiltersWithdraw}
                            type="primary">{this.props.intl.messages.filter}</Button>
                    </Form>
                </div>

                <Spin indicator={antIcon} spinning={this.props.withdraw.inProcess}>
                    <Table dataSource={data.sort(sorter)}
                        columns={columns}
                        className="ta-aff-table ta--mt-8"
                        pagination={false}
                        footer={() =>
                            <div className='ta--flex ta--justify-between rtl--row-reverse'>
                                <div className="ta--total-rows">{this.props.intl.messages.total_rows}: {mainWithdraw && mainWithdraw.RowCount}</div>
                                <div>{this.props.intl.messages.summary}: <span className='ta--green ta--fw-b'>{mainWithdraw && Utils.numberWithCommas(mainWithdraw.TotalAmount)}</span></div>
                            </div>}>
                        ></Table>
                    <Pagination defaultCurrent={1} pageSize={13} total={mainWithdraw && mainWithdraw.RowCount} onChange={this.onPageChange} />
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        affiliates: state.affiliates,
        withdraw: state.withdraw
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return ({
        dispatch
    })
};

export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(Form.create()(Withdraw)));


// WEBPACK FOOTER //
// ./src/routes/mainAffilate/Withdraw/Withdraw.js